// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"564":"c101ce54","628":"0cd0f6ae"}[chunkId] + ".css";
};